import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { JwtModule } from '@auth0/angular-jwt';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { WebView } from '@awesome-cordova-plugins/ionic-webview/ngx';
import { MediaCapture } from '@ionic-native/media-capture/ngx';
import { Camera } from '@ionic-native/camera/ngx';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { UserService } from './services/user.service';
import { SentryService } from './services/sentry.service';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { translationProvider } from 'src/app/services/acceptlanguage';

import { SharedModule } from './shared/modules/shared-module';
import { environment } from 'src/environments/environment';
import * as Sentry from '@sentry/browser';

import { Storage } from '@capacitor/storage';

let apiHost: URL;
if (environment.apiUrl[0] === '/') {
  // relative url -> full url
  apiHost = new URL(
    `${window.location.protocol}//${window.location.host}${environment.apiUrl}`
  );
} else {
  apiHost = new URL(environment.apiUrl);
}

Sentry.init({
  dsn: environment.dsnSentry,
});

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: () =>
          Storage.get({ key: UserService.JWT_KEY }).then(({ value }) => value),
        authScheme: 'JWT ',
        whitelistedDomains: [apiHost.host, /localhost(?:$|:\d+)/],
        skipWhenExpired: true,
      },
    }),
    IonicModule.forRoot(),
    AppRoutingModule,
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    File,
    WebView,
    MediaCapture,
    Camera,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: ErrorHandler, useClass: SentryService },
    translationProvider,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
